/* eslint-disable import/no-anonymous-default-export */

export default [
  {
    id: 0,
    title: "Long Event",
    allDay: true,
    start: new Date(new Date().setHours(new Date().getHours() - 3)),
    end: new Date(new Date().setHours(new Date().getHours() + 3)),
    hexColor: '50b74e'
  },
  {
    id: 1,
    title: "test Event",
    start: new Date('2023-01-26'),
    end: new Date('2023-01-28'),
    hexColor: 'c04e44'
  },
  {
    id: 2,
    title: "Today",
    start: new Date(new Date().setHours(new Date().getHours() - 5)),
    end: new Date(new Date().setHours(new Date().getHours() + 5)),
    hexColor:'2ca5dc'
  },
];
